import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

function AddCounterModal({
  open,
  onClose,
  initialCounter,
  initialMaxLimit,
  onSave,
}) {
  const [draftCounter, setDraftCounter] = useState(initialCounter);
  const [draftMaxLimit, setDraftMaxLimit] = useState(initialMaxLimit);

  useEffect(() => {
    setDraftCounter(initialCounter);
    setDraftMaxLimit(initialMaxLimit);
  }, [initialCounter, initialMaxLimit, open]);

  const handleClose = () => {
    onClose();
  };

  const handleSave = () => {
    onSave(Number(draftCounter), Number(draftMaxLimit));
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
        onClick={(event) => {
          if (event.target === event.currentTarget) {
            handleClose();
          }
        }}
      >
        <Box
          sx={{
            width: 400,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography id="modal-title" variant="h6" component="h2" gutterBottom>
            Enter Counter Details
          </Typography>
          <TextField
            label="Counter Value"
            variant="outlined"
            value={draftCounter}
            onChange={(e) => setDraftCounter(e.target.value)}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="Max Company Limit"
            variant="outlined"
            value={draftMaxLimit}
            onChange={(e) => setDraftMaxLimit(e.target.value)}
            fullWidth
          />
          <Button
            onClick={handleSave}
            variant="contained"
            sx={{ mt: 2 }}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default AddCounterModal;
